import { render, staticRenderFns } from "./SubjectLayoutForPageAndSection.vue?vue&type=template&id=7e572b0a&scoped=true&"
import script from "./SubjectLayoutForPageAndSection.vue?vue&type=script&lang=js&"
export * from "./SubjectLayoutForPageAndSection.vue?vue&type=script&lang=js&"
import style0 from "./SubjectLayoutForPageAndSection.vue?vue&type=style&index=0&id=7e572b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e572b0a",
  null
  
)

export default component.exports